import React from 'react';
import { useDispatch } from 'react-redux';
import { setCardContent } from 'services/api/communication';
import { CreateAutomationForm } from '../CreateAutomationForm/CreateAutomationForm';
import { SendTextMessege } from './SendTextMessege/SendTextMessege';
import { Wrapper } from './Theme';
export const TextMessege = ({activeStep,formik,setCardName,setActiveStep,eventTypes,automationType = "sms"}) => {
  const dispatch = useDispatch()
    const renderContent = () => {
        switch (activeStep) {
          case 0:
            return (
           <CreateAutomationForm formik={formik} 
           onNext={()=>{setActiveStep(2)}} 
           onBack={()=>dispatch(setCardContent("Create Campaign"))}
           dropDownType={eventTypes}
           
           />
            );
          case 1:
            return (
                <></>
            );
          case 2:
            return (
              <SendTextMessege onBack={()=>{setActiveStep(0)}}  formik={formik} setCardName={setCardName} automationType={automationType}/>
            );
    
          default:
            return;
        }
      };
    
      return <Wrapper activeStep={activeStep !== 2}>{renderContent()}</Wrapper>;
};

